export default {
  install(Vue) {
    Vue.prototype.$mock = {
      request: ({ params, data, timer = 1000 } = {}) => new Promise((resolve) => {
        const perPage = params?.['per-page'] || 20;
        const currentPage = params?.page || 1;
        const itemsCount = Array.isArray(data) ? data?.length : 1;
        setTimeout(() => {
          resolve({
            headers: {
              'x-pagination-total-count': itemsCount,
              'x-pagination-current-page': currentPage,
              'x-pagination-page-count': Math.ceil(itemsCount / perPage) || 1,
              'x-pagination-per-page': perPage,
            },
            data: {
              data,
              result_code: 'FLSCS',
            },
          });
        }, timer); // 1s
      }),
    };
  },
};
